import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import JobDTO from '@src/adapters/dto/job/JobDTO';
import { useMemo } from 'react';
import theme from '@src/theme';
import {
  dayAndNumber,
  getDaysBetween,
  isTheSameDay,
} from '@src/utils/dateUtils';
import CrewName from '@src/components/user/CrewName';
import CrewButton from './CrewButton';
import JobAvailabilityDTO from '@src/adapters/dto/job/JobAvailabilityDTO';

interface Props {
  job: JobDTO;
  availabilityClicked(availability: JobAvailabilityDTO): void;
}

function AssignCrew({ job, availabilityClicked }: Props) {
  const days = useMemo(() => {
    if (job.startDate && job.endDate) {
      return getDaysBetween(job.startDate, job.endDate);
    }
    return [];
  }, [job.startDate, job.endDate]);

  const users = useMemo(() => {
    const counts = new Map<string, number>();

    job.availabilities.forEach((a) => {
      counts.set(a.userId, (counts.get(a.userId) || 0) + 1);
    });

    return Array.from(counts.entries())
      .sort((a, b) => b[1] - a[1])
      .map(([id]) => id);
  }, [job.availabilities]);

  return (
    <Paper elevation={8}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.primary,
            paddingBottom: theme.spacing(2),
          }}>
          Assign Crew
        </Typography>
      </Box>
      <TableContainer>
        <Table
          aria-labelledby="tableTitle"
          size="small"
          aria-label="Contents table">
          <TableHead>
            <TableRow>
              <TableCell
                component="th"
                align="left"
                sx={{ width: '15%' }}></TableCell>
              {days.map((d, index) => (
                <TableCell
                  key={index}
                  component="th"
                  align="center"
                  sx={{
                    width: `${85 / days.length}%`,
                  }}>
                  {dayAndNumber(d)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((u, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  <CrewName id={u} />
                </TableCell>
                {days.map((d, index) => (
                  <TableCell component="th" align="center" key={index}>
                    <CrewButton
                      availability={job.availabilities.find(
                        (a) => isTheSameDay(a.date, d) && a.userId === u
                      )}
                      availabilityClicked={availabilityClicked}
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default AssignCrew;
